import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import "datatables.net-responsive-bs4";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import ImageNotFound from '../../assets/images/not-found.png';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const PageServices = () => {
    const [loading, setLoading] = useState(false);
    const [page_service_id, setPageServiceId] = useState(0);
    const [service_title, setServiceTitle] = useState('');
    const [service_sub_title, setServiceSubTitle] = useState('');
    const [service_icon, setServiceIcon] = useState('');
    const [section_services, setSectionServices] = useState([]);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;
    const URLZFILES = process.env.REACT_APP_API_ZFILES;

    useEffect(() => {
        setTimeout(() => {
            $('.select2').select2({ width: "100%" });
        }, 100);
        getAll();
    }, []);

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy();
        await axios.get(ENDPOINT + "get-all-services").then((response) => {
            setSectionServices(response.data.data);
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 10,
                    responsive: true,
                    autoWidth: true,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar por servicio",
                    },
                });
                setLoading(false);
            }, 100);
        })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    };

    const handleNew = () => {
        clearField();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append("service_title", service_title);
        form.append("service_sub_title", service_sub_title);
        form.append("service_icon", service_icon);
        if (page_service_id === 0) {
            await axios
                .post(ENDPOINT + "save-service", form)
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            setLoading(true);
            await axios
                .put(ENDPOINT + "update-service/" + page_service_id, {
                    service_title: service_title,
                    service_sub_title: service_sub_title,
                    service_icon: service_icon
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(true);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const handleFileChangeIcon = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/services/');
        await axios.post(ENDPOINT + 'upload-page-service', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setServiceIcon(response.data.data.pathFile);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 1000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const clearField = () => {
        setPageServiceId(0);
        setServiceTitle('');
        setServiceSubTitle('');
        setServiceIcon('');
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .put(ENDPOINT + "get-service-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-service/" + id)
            .then((response) => {
                setLoading(false);
                setPageServiceId(response.data.data.page_service_id);
                setServiceTitle(response.data.data.service_title);
                setServiceSubTitle(response.data.data.service_sub_title);
                setServiceIcon(response.data.data.service_icon);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-service/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];

    return (
        <>
            {loading && <Loader />}
            <div className="page-service-wrapper">
                <div className="page-service-container">
                    <ContentHeader title="Administración Página Servicios" />
                    
                    <div className="page-service-card">
                        <div className="page-service-header">
                            <h3 className="page-service-title">
                                <i className="bi bi-gear-fill me-2"></i> 
                                Gestionar Información de Servicios
                            </h3>
                            <p className="page-service-subtitle">
                                Complete los campos para gestionar los servicios disponibles
                            </p>
                        </div>

                        <div className="page-service-content">
                            <div className="page-service-actions-top">
                                <button
                                    onClick={handleNew}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                    className="page-service-btn btn btn-succcess"
                                >
                                    <i className="fas fa-plus"></i>
                                    Agregar Servicio
                                </button>
                                <button
                                    onClick={resetPage}
                                    className="page-service-btn btn btn-info"
                                >
                                    <i className="fa fa-refresh"></i>
                                    Recargar
                                </button>
                            </div>

                            {/* Table content */}
                            <div className="table-responsive">
                                <table className="table table-hover table-striped main">
                                    <thead>
                                        <tr>
                                            <th width="8%" className="text-center">#</th>
                                            <th className="text-left">Titulo</th>
                                            <th className="text-left">SubTitulo</th>
                                            <th className="text-center">Icono</th>
                                            <th width="10%" className="text-center">Estado</th>
                                            <th width="10%" className="text-center">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {section_services.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <kbd># {item.page_service_id}</kbd>
                                                </td>
                                                <td>
                                                    {item.service_title}
                                                </td>
                                                <td>
                                                    {item.service_sub_title}
                                                </td>
                                                <td className="text-center">
                                                    <img
                                                        className="rounded border border-secondary img-fluid"
                                                        width={80}
                                                        height={80}
                                                        src={item.service_icon ? URLZFILES + item.service_icon : ImageNotFound}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <div data-toggle="tooltip" data-placement="top" title="Estado">
                                                        <Switch
                                                            checkedIcon={false}
                                                            uncheckedIcon={false}
                                                            checked={item.status === 1 ? true : false}
                                                            onChange={() => toggleSwitch(item.page_service_id)}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div>
                                                        <button
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#modal-default"
                                                            className="btn-sm btn btn-warning me-1"
                                                            onClick={() => handleEdit(item.page_service_id)}
                                                        >
                                                            <i className="fa-solid fa-pen-to-square"></i>
                                                        </button>
                                                        <button
                                                            className="btn-sm btn btn-danger me-1"
                                                            onClick={() => handleDelete(item.page_service_id, item.service_title)}
                                                        >
                                                            <i className="fa-solid fa-trash-can"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <div className="modal fade" id="modal-default" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="page-service-modal-header">
                            <h4 className="page-service-modal-title">
                                <i className="bi bi-gear-fill me-2"></i>
                                {page_service_id === 0 ? "Nuevo Servicio" : "Editar Servicio"}
                            </h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="page-service-form-section">
                                    <h4 className="page-service-section-title">Información del Servicio</h4>
                                    <div className="page-service-grid">
                                        <div className="col-12 col-sm-12 mt-3">
                                            <div className="form-group">
                                                <label htmlFor="service_title" className="col-form-label col-form-label-sm">
                                                    Titulo
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-sm`}
                                                    placeholder="Ingrese titulo"
                                                    id="service_title"
                                                    name="service_title"
                                                    value={service_title}
                                                    onChange={(e) => setServiceTitle(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 mt-3">
                                            <div className="form-group">
                                                <label htmlFor="service_sub_title" className="col-form-label col-form-label-sm">
                                                    Sub Titulo
                                                </label>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={service_sub_title}
                                                    onChange={setServiceSubTitle}
                                                    modules={modules}
                                                    formats={formats}
                                                    placeholder={'Ingrese sub titulo'}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 mt-3">
                                            <div className="form-group">
                                                <label htmlFor="service_icon" className="col-form-label col-form-label-sm">
                                                    Imagen (Recomendación 80px por 80px)
                                                </label>
                                                <br/>
                                                <input
                                                    type="file"
                                                    name="file"
                                                    onChange={handleFileChangeIcon}
                                                />
                                            </div>
                                            <img
                                                className="rounded border border-secondary img-fluid mt-3"
                                                width={80}
                                                height={80}
                                                src={service_icon ? URLZFILES + service_icon : ImageNotFound}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="page-service-form-section">
                                    <h4 className="page-service-section-title">Descripción</h4>
                                    <div className="form-group">
                                        <label className="page-service-label">
                                            Descripción<span className="page-service-required">*</span>
                                        </label>
                                        <ReactQuill
                                            theme="snow"
                                            value={service_sub_title}
                                            onChange={setServiceSubTitle}
                                            modules={modules}
                                            formats={formats}
                                            placeholder="Ingrese la descripción del servicio"
                                            className="page-service-editor"
                                        />
                                        <span className="page-service-hint">Describa las características del servicio</span>
                                    </div>
                                </div>

                                <div className="page-service-form-section">
                                    <h4 className="page-service-section-title">Imagen</h4>
                                    <div className="page-service-image-upload">
                                        <div className="page-service-preview">
                                            <img
                                                src={service_icon ? URLZFILES + service_icon : ImageNotFound}
                                                alt="Vista previa"
                                                className="page-service-preview-img"
                                            />
                                        </div>
                                        <div className="page-service-upload-controls">
                                            <input
                                                type="file"
                                                id="service-image"
                                                className="page-service-input-file"
                                                onChange={handleFileChangeIcon}
                                            />
                                            <label htmlFor="service-image" className="page-service-upload-label">
                                                <i className="fas fa-upload"></i>
                                                Seleccionar Imagen
                                            </label>
                                            <span className="page-service-hint">Formato recomendado: JPG, PNG. Tamaño máximo: 2MB</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="page-service-form-actions">
                                <button type="submit" className="page-service-btn page-service-btn-primary">
                                    <i className="fa-regular fa-floppy-disk"></i>
                                    {page_service_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    type="button"
                                    className="page-service-btn page-service-btn-secondary"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PageServices;